<template>
  <div class="content">
    <div class="infinite-list-wrapper" style="overflow: auto; height: 100%">
      <ul
        class="list"
        v-infinite-scroll="load"
        infinite-scroll-disabled="disabled"
      >
        <li
          @click="jumpDetails(article.id, article.infoUrl)"
          v-for="article in panelDataList"
          class="list-item"
          :key="article.id"
        >
          <div class="text-group_58">
            <div class="text_84">
              <img v-if="article.isWechat == 1" src="../assets/wx.svg" alt="" />
              <img
                v-if="article.isWechat == 0"
                src="../assets/net.svg"
                alt=""
              />
            </div>
            <span class="text_85" style="width: 90%">
              {{ article.title.replace(/\/?.+?\/?>/g, "") }}</span
            >

            <!-- <div class="list_footer" v-if="type == 5">
              <span class="text_111">
                <el-tag
                  class="tag"
                  size="mini"
                  v-for="(tag, tagIdx) in article.tagList"
                  :key="tagIdx"
                  style="margin-right: 5px"
                >
                  {{ tag }}</el-tag
                >
              </span>
              <span class="text_86">({{ article.publishTime }})</span>
            </div> -->
            <div class="row_footer">
              <span v-if="index === 0" class="text_111">
                {{ article.source }}</span
              >
              <span v-else class="text_111"> </span>
              <span class="text_86"> ({{ article.publishTime }})</span>
            </div>
          </div>
        </li>
      </ul>
      <p class="footer" v-if="loading">加载中...</p>
      <p class="footer" v-if="noMore">没有更多了</p>
    </div>
  </div>
</template>

<script>
import { getArticlePage, getArticleByIdList } from "@/api/api";
export default {
  props: ["type", "index"],
  data() {
    return {
      count: 10,
      loading: false,
      panelDataList: [],
      pageNo: 1,
      noMore: false,
    };
  },
  computed: {
    disabled() {
      return this.loading || this.noMore;
    },
    isLogin() {
      return sessionStorage.getItem("isLogin") === "1";
    },
  },
  created() {
    this.load();
  },
  methods: {
    jumpDetails(id, infoUrl) {
      let routerUrl = this.$router.resolve({
        path: "/articleDetails",
        query: { id, type: this.type },
      });
      if (this.type === "10") {
        window.open(routerUrl.href);
      } else {
        window.open(this.isLogin ? routerUrl.href : infoUrl);
        if (!this.isLogin) {
          getArticleByIdList({
            id,
            type: this.type,
          });
        }
      }
    },
    async load() {
      if (this.noMore) {
        return;
      }
      this.loading = true;
      //获取文章列表
      let obj = {
        condition: {
          keywords: "",
          publicTime: "",
          sort: "",
          sourceDate: "",
          subTypeName: "",
          title: "",
          type: this.type,
        },
        offset: "",
        order: "",
        pageNo: this.pageNo,
        pageSize: 5,
        sidx: "",
      };

      getArticlePage(obj).then((res) => {
        if (res.data.list.length === 0) {
          this.noMore = true;
        }
        this.loading = false;
        this.pageNo++;
        this.panelDataList.push(...res.data.list);
        this.panelDataList.map((item) => {
          let list = [];
          if (item.typeTwo) {
            if (item.typeTwo.indexOf("科研诚信") > -1) {
              list.push("诚信");
            }
            if (item.typeTwo.indexOf("科研伦理") > -1) {
              list.push("伦理");
            }
            item.tagList = list;
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  ul {
    li {
      box-sizing: border-box;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
      cursor: pointer;
      width: 100%;
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      padding-right: 10px;
      .row_footer {
        display: flex;
        justify-content: space-between;
      }
      .text-group_58 {
        // display: flex;
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;
        padding-bottom: 5px;
        .text_111 {
          font-size: 14px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.4);
          width: 15%;
          overflow: hidden;
          text-overflow: ellipsis;
          word-spacing: none;
          -webkit-line-clamp: 1; //这里就是设置超出几行隐藏
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }
        .text_84 {
          float: left;
          width: 16px;
          height: 16px;
          margin-top: 3px;
          margin-right: 4px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .text_85 {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          word-spacing: none;
          -webkit-line-clamp: 1; //这里就是设置超出几行隐藏
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }
        .list_footer {
          display: flex;
          justify-content: space-between;
        }
        .text_86 {
          color: rgba(0, 0, 0, 0.4);
          font-size: 14px !important;
          float: right !important;
        }
      }
      .box_100 {
        .box_101 {
          // float: left;
          margin-top: 10px;
          .text_86 {
            // float: left;
            color: rgba(0, 0, 0, 0.4);
          }
          .text_86:nth-child(1) {
            color: rgba(0, 0, 0, 0.4);
            padding-right: 20px;
          }
        }
      }
    }
    li:hover {
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;

      line-height: 22px;
      color: #13509f;
    }
  }
  .footer {
    width: 100%;
    text-align: center;
    color: #bebdbd;
  }
}

/*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 4px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.1);
}
</style>
